import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { translationPropType } from '@eb/i18n';
import Icon from 'eventbrite_design_system/icon/Icon';
import { ICON_TYPE_PROP_TYPE } from 'eventbrite_design_system/icon/constants';

import './pageHeader.scss';

const HeaderIcon = ({ iconType }) => {
    const classes = classNames(
        'eds-l-mar-bot-6',
        'eds-fx--pop eds-fx--delay-1',
        'eds-bg-color--white',
        `header-icon--${iconType}`,
    );

    return (
        <div className={classes}>
            <Icon size="medium" type={iconType} color="ui-orange" />
        </div>
    );
};

const HeaderTitle = ({ headerText, subtitleText }) => (
    <div className="eds-text-hs eds-l-mar-bot-10">{headerText}</div>
);

const HeaderSubTitle = ({ subtitleText }) => {
    let component = null;

    const headerSubTitleClasses = classNames(
        //Adding the set style so that the subtitle text maintains consistent height as text length changes with screen size.
        //Prevents email field from jumping around the page.
        'eds-l-mar-bot-8',
        'eds-text-color--grey-600',
        'eds-l-mar-hor-3',
        'eds-text-bm',
    );

    if (subtitleText) {
        component = <div className={headerSubTitleClasses}>{subtitleText}</div>;
    }

    return component;
};

export default class PageHeader extends React.PureComponent {
    static propTypes = {
        headerText: translationPropType.isRequired,
        iconType: ICON_TYPE_PROP_TYPE.isRequired,
        subtitleText: translationPropType,
        iconColor: PropTypes.string,
    };

    static defaultProps = {
        iconColor: 'grey-900',
    };

    render() {
        const { headerText, subtitleText, iconType, iconColor } = this.props;

        return (
            <div className="authentication__page-header eds-text--center">
                <HeaderIcon iconType={iconType} iconColor={iconColor} />
                <HeaderTitle
                    headerText={headerText}
                    subtitleText={subtitleText}
                />
                <HeaderSubTitle subtitleText={subtitleText} />
            </div>
        );
    }
}
